// import {
//   IonPage,
//   IonHeader,
//   IonToolbar,
//   IonButtons,
//   IonMenuButton,
//   IonTitle,
//   IonContent,
//   IonLoading,
// } from "@ionic/react";
// import {
//   Grid,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Button,
//   Card,
//   CardContent,
//   Typography,
//   Container,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TablePagination,
//   TableRow,
//   TextField,
// } from "@mui/material";
// import axios from "axios";
// import React, { useEffect, useState } from "react";
// import { useParams, useLocation } from "react-router";
// import { requestID, baseUrl, config } from "../../common/utils";
// import { useBusinessContext } from "../../BusinessContext";
// import  styles from "./OverdueSavingsReport.module.css";

// const OverdueSavingsReport = () => {
//   // const { name } = useParams<{ name: string }>();
//   const location = useLocation();
//   const name = location.pathname.split("/").pop()?.replace(/%20/g, " ") || "Overdue Savings Report";
//   const { selectedBusiness} = useBusinessContext()
//   const currentYear = new Date().getFullYear();
//   const [selectedMonth, setSelectedMonth] = useState("");
//   const [selectedYear, setSelectedYear] = useState("");
//   const [searchQuery, setSearchQuery] = useState("");
//   const [reportData, setReportData] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [status, setStatus] = useState({ loading: false, error: false });
//   const [showAlert, setShowAlert] = useState<boolean>(false);
//   const [alertMsg, setAlertMsg] = useState<string>("");

//   const handleSearchChange = (event) => {
//     setSearchQuery(event.target.value);
//     setPage(0);
//   };

//   const filteredData = reportData?.filter(
//     (row) =>
//       row.fullName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       row.phone?.toLowerCase().includes(searchQuery.toLowerCase())
//   );

//   const handleChangePage = (newPage) => {
//     setPage(newPage);
//   };
//   const onShowAlert = () => {
//     setShowAlert(true);
//     setTimeout(() => setShowAlert(false), 5000);
//   };
//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const months = [
//     { id: 1, name: "January" },
//     { id: 2, name: "February" },
//     { id: 3, name: "March" },
//     { id: 4, name: "April" },
//     { id: 5, name: "May" },
//     { id: 6, name: "June" },
//     { id: 7, name: "July" },
//     { id: 8, name: "August" },
//     { id: 9, name: "September" },
//     { id: 10, name: "October" },
//     { id: 11, name: "November" },
//     { id: 12, name: "December" },
//   ];

//   const years = Array.from(new Array(10), (_, index) => currentYear - index);

//   const onGetOverDueSavings = async () => {
//     setStatus({ loading: true, error: false });
//     console.log(selectedMonth, selectedYear);
//     try {
//       const formData = new FormData();
//       formData.append("requestID", requestID());
//       formData.append("month", selectedMonth);
//       formData.append("year", selectedYear);
//       formData.append("business_id", selectedBusiness.business_id);
//       formData.append("branch_id", selectedBusiness.branch_id);
//       const response = await axios.post(
//         baseUrl() + "applyloans/getOverDueSavings",
//         formData,
//         config
//       );
//       console.log(response);
//       const data = await response.data;
//       if (data.status === true) {
//         setReportData(data.data);
//         setStatus({ loading: false, error: false });
//         setAlertMsg(response.data.message);
//         onShowAlert();
//       } else {
//         setAlertMsg(response.data.message);
//         setReportData([]);
//         onShowAlert();
//         setStatus({ loading: false, error: true });
//       }
//     } catch (error) {
//       setStatus({ loading: false, error: false });

//       console.error("Error approving loan:", error);
//     }
//   };

//   return (
//     <IonPage>
//       <IonHeader>
//         <IonToolbar className={styles.headerToolbar}>
//           <IonButtons slot="start">
//             <IonMenuButton />
//           </IonButtons>
//           <IonTitle>{name}</IonTitle>
//         </IonToolbar>
//       </IonHeader>

//       <IonContent fullscreen>
//         <IonHeader collapse="condense">
//           <IonToolbar>
//             <IonTitle size="large">{name}</IonTitle>
//           </IonToolbar>
//         </IonHeader>
//         <Container component="main" sx={{ mt: 4, mb: 2 }}>
          
//           <Grid
//             container
//             spacing={2}
//             justifyContent="center"
//             alignItems="center"
//           >
//             {/* Month Dropdown */}
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="month-label">Select Month</InputLabel>
//                 <Select
//                   labelId="month-label"
//                   value={selectedMonth}
//                   onChange={(e) => setSelectedMonth(e.target.value)}
//                   label="Select Month"
//                 >
//                   <MenuItem value={""}>Please select a Month</MenuItem>
//                   {months.map((month, index) => (
//                     <MenuItem key={index} value={month.id}>
//                       {month.name}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Year Dropdown */}
//             <Grid item xs={12} sm={6} md={4}>
//               <FormControl fullWidth>
//                 <InputLabel id="year-label">Select Year</InputLabel>
//                 <Select
//                   labelId="year-label"
//                   value={selectedYear}
//                   onChange={(e) => setSelectedYear(e.target.value)}
//                   label="Select Year"
//                 >
//                   <MenuItem value={""}>Please select a Year</MenuItem>

//                   {years.map((year, index) => (
//                     <MenuItem key={index} value={year}>
//                       {year}
//                     </MenuItem>
//                   ))}
//                 </Select>
//               </FormControl>
//             </Grid>

//             {/* Generate Report Button */}
//             <Grid item xs={12} sm={6} md={4}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={onGetOverDueSavings}
//                 fullWidth
//                 disabled={!selectedMonth || !selectedYear}
//               >
//                 Generate Report
//               </Button>
//             </Grid>

//             {reportData.length > 0 && (
//               // <Grid item xs={12} sm={8} md={10}>
//               <TextField
//                 sx={{ my: 2 }}
//                 label="Search by Name or Email"
//                 variant="outlined"
//                 fullWidth
//                 value={searchQuery}
//                 onChange={handleSearchChange}
//               />
//               // </Grid>
//             )}

//             {/* Report Display Card */}
//             {filteredData.length > 0 ? (
//               <TableContainer component={Paper} sx={{ mt: 2 }}>
//                 <Table>
//                   <TableHead>
//                     <TableRow>
//                       <TableCell>ID</TableCell>
//                       <TableCell>Name</TableCell>
//                       <TableCell>Email</TableCell>
//                       <TableCell>Phone</TableCell>
//                       <TableCell>Joined Date</TableCell>
//                     </TableRow>
//                   </TableHead>
//                   <TableBody>
//                     {filteredData
//                       .slice(
//                         page * rowsPerPage,
//                         page * rowsPerPage + rowsPerPage
//                       )
//                       .map((row, i) => (
//                         <TableRow key={row.id}>
//                           <TableCell>{i + 1}</TableCell>
//                           <TableCell>{row.fullName}</TableCell>
//                           <TableCell>{row.email}</TableCell>
//                           <TableCell>{row.phone}</TableCell>
//                           <TableCell>{row.joinedDate}</TableCell>
//                         </TableRow>
//                       ))}
//                   </TableBody>
//                 </Table>
//                 {/* </TableContainer> */}

//                 {/* Pagination */}
//                 <TablePagination
//                   rowsPerPageOptions={[5, 10, 25]}
//                   component="div"
//                   count={reportData.length}
//                   rowsPerPage={rowsPerPage}
//                   page={page}
//                   onPageChange={handleChangePage}
//                   onRowsPerPageChange={handleChangeRowsPerPage}
//                 />
//               </TableContainer>
//             ) : (
//               <Grid item xs={12} sm={8} md={10} sx={{ maxHeight: 500 }}>
//                 <Paper
//                   style={{
//                     padding: "100px",
//                     textAlign: "center",
//                     maxHeight: "500px",
//                   }}
//                 >
//                   <Typography variant="h6" color="textSecondary">
//                     No data available for the selected month and year.
//                   </Typography>
//                 </Paper>
//               </Grid>
//             )}
//           </Grid>
//         </Container>
//         <IonLoading
//           message="Please wait..."
//           spinner="circles"
//           isOpen={status.loading}
//         />
//       </IonContent>
//     </IonPage>
//   );
// };

// export default OverdueSavingsReport;


import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonMenuButton,
  IonTitle,
  IonContent,
  IonLoading,
} from "@ionic/react";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Box,
  Fade,
  Slide,
  Zoom,
  Grow,
  alpha,
  useTheme,
  IconButton,
  Collapse,
  CircularProgress,
  Chip,
} from "@mui/material";
import {
  Search as SearchIcon,
  CalendarMonth as CalendarIcon,
  FilterAlt as FilterIcon,
  Download as DownloadIcon,
  Person as PersonIcon,
  Email as EmailIcon,
  Phone as PhoneIcon,
  Event as EventIcon,
  Warning as WarningIcon,
  Refresh as RefreshIcon,
} from "@mui/icons-material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router";
import { requestID, baseUrl, config } from "../../common/utils";
 import styles from "./OverdueSavingsReport.module.css";
import { useBusinessContext } from "../../context/business-context";

interface ReportData {
  id: string;
  fullName: string;
  email: string;
  phone: string;
  joinedDate: string;
  overdueAmount?: number;
  overdueDays?: number;
}

const OverdueSavingsReport = () => {
  const location = useLocation();
  const theme = useTheme();
  const name = location.pathname.split("/").pop()?.replace(/%20/g, " ") || "Overdue Savings Report";
  const { selectedBusiness } = useBusinessContext();
  
  const currentYear = new Date().getFullYear();
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [reportData, setReportData] = useState<ReportData[]>([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [status, setStatus] = useState({ loading: false, error: false });
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertMsg, setAlertMsg] = useState<string>("");

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setPage(0);
  };

  const filteredData = reportData?.filter(
    (row) =>
      row.fullName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.phone?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      row.email?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onShowAlert = () => {
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 5000);
  };

  const months = [
    { id: 1, name: "January", icon: "❄️" },
    { id: 2, name: "February", icon: "💝" },
    { id: 3, name: "March", icon: "🌱" },
    { id: 4, name: "April", icon: "🌧️" },
    { id: 5, name: "May", icon: "🌺" },
    { id: 6, name: "June", icon: "☀️" },
    { id: 7, name: "July", icon: "🏖️" },
    { id: 8, name: "August", icon: "🌻" },
    { id: 9, name: "September", icon: "🍂" },
    { id: 10, name: "October", icon: "🎃" },
    { id: 11, name: "November", icon: "🦃" },
    { id: 12, name: "December", icon: "🎄" },
  ];

  const years = Array.from(new Array(10), (_, index) => currentYear - index);

  const onGetOverDueSavings = async () => {
    setStatus({ loading: true, error: false });
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      formData.append("month", selectedMonth);
      formData.append("year", selectedYear);
      formData.append("business_id", selectedBusiness.business_id);
      formData.append("branch_id", selectedBusiness.branch_id);
      
      const response = await axios.post(
        baseUrl() + "applyloans/getOverDueSavings",
        formData,
        config
      );
      
      const data = response.data;
      if (data.status === true) {
        setReportData(data.data);
        setStatus({ loading: false, error: false });
        setAlertMsg(data.message);
        onShowAlert();
      } else {
        setAlertMsg(data.message);
        setReportData([]);
        setStatus({ loading: false, error: true });
        onShowAlert();
      }
    } catch (error) {
      setAlertMsg("Failed to generate report. Please try again.");
      setStatus({ loading: false, error: true });
      onShowAlert();
      console.error("Error generating report:", error);
    }
  };

  const handleExport = () => {
    // Export functionality would go here
    console.log("Exporting report data...");
  };

  return (
    <IonPage className="pushDown">
      <IonHeader>
        <IonToolbar className={styles.headerToolbar}>
          <IonButtons slot="start">
            <IonMenuButton className={styles.menuButton} />
          </IonButtons>
          <IonTitle className={styles.title}>{name}</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen className={styles.content}>
        {/* Alert Notification */}
        <Collapse in={showAlert} className={styles.alertContainer}>
          <Box className={`${styles.alert} ${status.error ? styles.errorAlert : styles.successAlert}`}>
            <WarningIcon className={styles.alertIcon} />
            <Typography variant="body2" className={styles.alertText}>
              {alertMsg}
            </Typography>
          </Box>
        </Collapse>

        <Container maxWidth="lg" className={styles.container}>
          <Grow in={true} timeout={800}>
            <Paper elevation={0} className={styles.paper}>
              {/* Header Section */}
              <Slide direction="down" in={true} timeout={500}>
                <Box className={styles.header}>
                  <Box className={styles.headerContent}>
                    <CalendarIcon className={styles.headerIcon} />
                    <Typography variant="h3" className={styles.headerTitle}>
                      Overdue Savings Report
                    </Typography>
                  </Box>
                  <Typography variant="body1" className={styles.headerSubtitle}>
                    Track and manage overdue savings payments
                  </Typography>
                </Box>
              </Slide>

              {/* Filter Section */}
              <Fade in={true} timeout={700}>
                <Box className={styles.filterSection}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth className={styles.formControl}>
                        <InputLabel id="month-label" className={styles.label}>
                          <FilterIcon className={styles.inputIcon} />
                          Select Month
                        </InputLabel>
                        <Select
                          labelId="month-label"
                          value={selectedMonth}
                          onChange={(e) => setSelectedMonth(e.target.value)}
                          label="Select Month"
                          className={styles.select}
                        >
                          <MenuItem value="">Select Month</MenuItem>
                          {months.map((month) => (
                            <MenuItem key={month.id} value={month.id} className={styles.menuItem}>
                              <span className={styles.monthIcon}>{month.icon}</span>
                              {month.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <FormControl fullWidth className={styles.formControl}>
                        <InputLabel id="year-label" className={styles.label}>
                          <FilterIcon className={styles.inputIcon} />
                          Select Year
                        </InputLabel>
                        <Select
                          labelId="year-label"
                          value={selectedYear}
                          onChange={(e) => setSelectedYear(e.target.value)}
                          label="Select Year"
                          className={styles.select}
                        >
                          <MenuItem value="">Select Year</MenuItem>
                          {years.map((year) => (
                            <MenuItem key={year} value={year} className={styles.menuItem}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid>

                    <Grid item xs={12} md={4}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={onGetOverDueSavings}
                        fullWidth
                        disabled={!selectedMonth || !selectedYear || status.loading}
                        className={styles.generateButton}
                        startIcon={status.loading ? <CircularProgress size={20} /> : <RefreshIcon />}
                      >
                        {status.loading ? "Generating..." : "Generate Report"}
                      </Button>
                    </Grid>
                  </Grid>
                </Box>
              </Fade>

              {/* Search Section */}
              {reportData.length > 0 && (
                <Fade in={true} timeout={900}>
                  <Box className={styles.searchSection}>
                    <Box className={styles.searchContainer}>
                      <SearchIcon className={styles.searchIcon} />
                      <TextField
                        label="Search by Name, Email or Phone"
                        variant="outlined"
                        fullWidth
                        value={searchQuery}
                        onChange={handleSearchChange}
                        className={styles.searchField}
                        InputProps={{
                          className: styles.searchInput,
                        }}
                      />
                    </Box>
                    <Button
                      variant="outlined"
                      color="secondary"
                      onClick={handleExport}
                      className={styles.exportButton}
                      startIcon={<DownloadIcon />}
                    >
                      Export
                    </Button>
                  </Box>
                </Fade>
              )}

              {/* Results Section */}
              {filteredData.length > 0 ? (
                <Zoom in={true} timeout={1000}>
                  <Box className={styles.resultsSection}>
                    <Box className={styles.resultsHeader}>
                      <Typography variant="h6" className={styles.resultsTitle}>
                        Overdue Savings Results
                      </Typography>
                      <Chip
                        label={`${filteredData.length} records found`}
                        color="primary"
                        variant="outlined"
                        className={styles.resultsCount}
                      />
                    </Box>

                    <TableContainer component={Paper} elevation={0} className={styles.tableContainer}>
                      <Table className={styles.table}>
                        <TableHead>
                          <TableRow className={styles.tableHeader}>
                            <TableCell className={styles.tableCell}>ID</TableCell>
                            <TableCell className={styles.tableCell}>
                              <PersonIcon className={styles.columnIcon} />
                              Name
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <EmailIcon className={styles.columnIcon} />
                              Email
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <PhoneIcon className={styles.columnIcon} />
                              Phone
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <EventIcon className={styles.columnIcon} />
                              Joined Date
                            </TableCell>
                            <TableCell className={styles.tableCell}>
                              <WarningIcon className={styles.columnIcon} />
                              Status
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredData
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, i) => (
                              <Grow in={true} timeout={300 + (i * 100)} key={i}>
                                <TableRow className={styles.tableRow}>
                                  <TableCell className={styles.tableCell}>{i + 1}</TableCell>
                                  <TableCell className={styles.tableCell}>
                                    <Box className={styles.nameCell}>
                                      <PersonIcon className={styles.cellIcon} />
                                      {row.fullName}
                                    </Box>
                                  </TableCell>
                                  <TableCell className={styles.tableCell}>{row.email}</TableCell>
                                  <TableCell className={styles.tableCell}>{row.phone}</TableCell>
                                  <TableCell className={styles.tableCell}>
                                    {new Date(row.joinedDate).toLocaleDateString()}
                                  </TableCell>
                                  <TableCell className={styles.tableCell}>
                                    <Chip
                                      label="Overdue"
                                      color="error"
                                      size="small"
                                      icon={<WarningIcon />}
                                      className={styles.statusChip}
                                    />
                                  </TableCell>
                                </TableRow>
                              </Grow>
                            ))}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25]}
                      component="div"
                      count={filteredData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      className={styles.pagination}
                    />
                  </Box>
                </Zoom>
              ) : (
                reportData.length === 0 && !status.loading && (
                  <Fade in={true} timeout={500}>
                    <Box className={styles.emptyState}>
                      <CalendarIcon className={styles.emptyIcon} />
                      <Typography variant="h6" className={styles.emptyText}>
                        No Overdue Savings Found
                      </Typography>
                      <Typography variant="body2" className={styles.emptySubtext}>
                        Select a month and year to generate the overdue savings report
                      </Typography>
                    </Box>
                  </Fade>
                )
              )}
            </Paper>
          </Grow>
        </Container>

        <IonLoading
          message="Generating Report..."
          spinner="circles"
          isOpen={status.loading}
          className={styles.loading}
        />
      </IonContent>
    </IonPage>
  );
};

export default OverdueSavingsReport;